import { getReporteCotizacionesAgenteDia, getReporteCotizacionesAgenteMes, getReporteCotizacionesAllDia, getReporteCotizacionesAllMes } from "../services/cotizacionService";
import { getAgentes } from "../services/serviceUsuarios";
import { FormatoFecha } from "../utils/FormatFecha";
const dataInicial = {
  cotizacioneAllDia: [],
  cotizacionesAllMes: [],
  cotizacionesAgeneteDia: [],
  cotizacionesAgenteMes: [],
  fechaMes: new Date(),
  fechaDia: new Date(),
  exito: 0,
  agemtesLista: [],
  agentesSeleccionados: [],
  agenteMes: new Date(),
  agenteDia: new Date(),
}

const GET_REPORTES_COTIZACIONES_MENSUALES_ACTION = "GET_REPORTES_COTIZACIONES_MENSUALES_ACTION"
const GET_REPORTES_COTIZACIONES_MENSUALES_FECHA_ACTION = "GET_REPORTES_COTIZACIONES_MENSUALES_FECHA_ACTION"
const GET_REPORTES_COTIZACIONES_DIA_ACTION = "GET_REPORTES_COTIZACIONES_DIA_ACTION"
const GET_REPORTES_COTIZACIONES_DIA_FECHA_ACTION = "GET_REPORTES_COTIZACIONES_DIA_FECHA_ACTION"
const GET_REPORTES_COTIZACIONES_AGENTE_DIA_ACTION = "GET_REPORTES_COTIZACIONES_AGENTE_DIA_ACTION"
const GET_REPORTES_COTIZACIONES_AGENTE_MES_ACTION = "GET_REPORTES_COTIZACIONES_AGENTE_MES_ACTION"
const GET_REPOSTES_COTIZACIONES_AGENTES_LISTA = "GET_REPOSTES_COTIZACIONES_AGENTES_LISTA"
const ADD_REPORTES_COTIZACIONES_AGENTE = "ADD_REPORTES_COTIZACIONES_AGENTE"
const ADD_REPORTES_COTIZACIONES_AGENTE_MES = "ADD_REPORTES_COTIZACIONES_AGENTE_MES"
const ADD_REPORTES_COTIZACIONES_AGENTE_DIA = "ADD_REPORTES_COTIZACIONES_AGENTE_DIA"
export default function reportesCotizacionesReducer(state = dataInicial, action) {
  switch (action.type) {
    case ADD_REPORTES_COTIZACIONES_AGENTE_MES:
      return { ...state, agenteMes: action.payload.agenteMes }
    case ADD_REPORTES_COTIZACIONES_AGENTE_DIA:
      return { ...state, agenteDia: action.payload.agenteDia }
    case ADD_REPORTES_COTIZACIONES_AGENTE:
      return { ...state, agentesSeleccionados: action.payload.agentesSeleccionados }
    case GET_REPORTES_COTIZACIONES_MENSUALES_ACTION:
      return { ...state, cotizacionesAllMes: action.payload.cotizacionesAllMes }
    case GET_REPORTES_COTIZACIONES_MENSUALES_FECHA_ACTION:
      return { ...state, cotizacionesAllMes: action.payload.cotizacionesAllMes, fechaMes: action.payload.fechaMes }
    case GET_REPORTES_COTIZACIONES_DIA_ACTION:
      return { ...state, cotizacioneAllDia: action.payload.cotizacioneAllDia }
    case GET_REPORTES_COTIZACIONES_DIA_FECHA_ACTION:
      return { ...state, cotizacioneAllDia: action.payload.cotizacioneAllDia, fechaDia: action.payload.fechaDia }
    case GET_REPORTES_COTIZACIONES_AGENTE_DIA_ACTION:
      return { ...state, cotizacionesAgeneteDia: action.payload.cotizacionesAgeneteDia }
    case GET_REPORTES_COTIZACIONES_AGENTE_MES_ACTION:
      return { ...state, cotizacionesAgenteMes: action.payload.cotizacionesAgenteMes }
    case GET_REPOSTES_COTIZACIONES_AGENTES_LISTA:
      return { ...state, agemtesLista: action.payload.agemtesLista }
    default:
      return state;
  }
}
//* metodos de cotizaciones agente
export const obtenerCotizcionesAgenteMesAction = ({ Fecha, IdAgente }) => async (dispatch) => {
  return await getReporteCotizacionesAgenteMes({ Fecha, IdAgente }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_AGENTE_MES_ACTION,
      payload: {
        cotizacionesAgenteMes: Response
      }
    })
    return Response
  }).catch(Error => {
    return []
  })
}
export const obtenerCotizcionesAgenteDiaAction = ({ Fecha, IdAgente }) => async (dispatch) => {
  return await getReporteCotizacionesAgenteDia({ Fecha, IdAgente }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_AGENTE_DIA_ACTION,
      payload: {
        cotizacionesAgeneteDia: Response
      }
    })
    return Response
  }).catch(Error => {
    return []
  })
}
//* metodos de cotizaciones all
export const obtenerCotizcionesMensualesFechaAction = ({ fecha }) => async (dispatch) => {
  return await getReporteCotizacionesAllMes({ Fecha: FormatoFecha({ date: fecha, formato: "MMyyyy" }) }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_MENSUALES_FECHA_ACTION,
      payload: {
        cotizacionesAllMes: Response,
        fechaMes: fecha
      }
    })
    return Response
  }).catch(Error => {
    return []
  })
}
export const obtenerCotizcionesMensualesAction = () => async (dispatch, getState) => {
  const { fechaMes } = getState().reporteCotizador
  return await getReporteCotizacionesAllMes({ Fecha: FormatoFecha({ date: fechaMes, formato: "MMyyyy" }) }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_MENSUALES_ACTION,
      payload: {
        cotizacionesAllMes: Response,
      }
    })
    return Response
  }).catch(Error => {
    return []
  })
}
export const obtenerCotizacionDiariosFechaAction = ({ fecha }) => async (dispatch) => {
  return await getReporteCotizacionesAllDia({ Fecha: FormatoFecha({ date: fecha, formato: "MMddyyyy" }) }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_DIA_FECHA_ACTION,
      payload: {
        cotizacioneAllDia: Response,
        fechaDia: fecha
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const obtenerCotizcionesDiariosAction = () => async (dispatch, getState) => {
  const { fechaDia } =  getState().reporteCotizador
  return await getReporteCotizacionesAllDia({ Fecha: FormatoFecha({ date: fechaDia, formato: "MMddyyyy" }) }).then(Response => {
    dispatch({
      type: GET_REPORTES_COTIZACIONES_DIA_ACTION,
      payload: {
        cotizacioneAllDia: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
//* Metodo para obtener agentes
export const obtenerAgentesListaAction = () => async (dispatch) => {
  return await getAgentes().then(Response => {
    dispatch({
      type: GET_REPOSTES_COTIZACIONES_AGENTES_LISTA,
      payload: {
        agemtesLista: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}
export const agregarAgentesLista = ({ newAgentes }) => (dispatch) => {
  dispatch({
    type: ADD_REPORTES_COTIZACIONES_AGENTE,
    payload: {
      agentesSeleccionados: newAgentes
    }
  })
}
export const agregarFechaMesAgente = ({mes}) => (dispatch) => {
  dispatch({
    type: ADD_REPORTES_COTIZACIONES_AGENTE_MES,
    payload: {
      agenteMes: mes
    }
  })
}
export const agregarFechaDiaAgente = ({dia}) => (dispatch) => {
  dispatch({
    type: ADD_REPORTES_COTIZACIONES_AGENTE_DIA,
    payload: {
      agenteDia: dia
    }
  })
}
